(function () {
  var fallbackSelector = '[data-native-boost-grid]';
  var appSelector = '.boost-sd__filter-product-list';
  var readyAppSelector = appSelector + '.boost-sd__filter-product-list--ready';

  function getTaxonomyContext() {
    var contextSource = Array.prototype.find.call(
      document.querySelectorAll(fallbackSelector),
      function (fallback) {
        return fallback.dataset.taxonomyContextId && fallback.dataset.taxonomyContextLevel;
      }
    );

    if (!contextSource) return null;

    return {
      id: contextSource.dataset.taxonomyContextId,
      level: contextSource.dataset.taxonomyContextLevel
    };
  }

  function decorateBoostProductLinks(app) {
    var context = getTaxonomyContext();
    if (!context) return;

    app.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var url;

      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;

      var fragmentParams = new URLSearchParams(url.hash.slice(1));
      fragmentParams.delete('vh-l1');
      fragmentParams.delete('vh-l2');
      fragmentParams.delete('vh-l3');
      fragmentParams.set('vh-l' + context.level, context.id);
      url.hash = fragmentParams.toString();
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function syncBoostFallback() {
    var appIsReady = document.querySelector(readyAppSelector) !== null;
    var nativeGridIsActive = false;

    document.querySelectorAll(fallbackSelector).forEach(function (fallback) {
      var sectionContainer = fallback.closest('.shopify-section') || fallback;
      var isBoostPlaceholder = fallback.dataset.nativeBoostPlaceholder !== 'false';
      var hideFallback = isBoostPlaceholder && appIsReady;

      if (!isBoostPlaceholder) nativeGridIsActive = true;

      fallback.hidden = hideFallback;
      sectionContainer.classList.toggle('native-boost-fallback-is-hidden', hideFallback);

      if (hideFallback) {
        fallback.setAttribute('aria-hidden', 'true');
      } else {
        fallback.removeAttribute('aria-hidden');
      }
    });

    document.querySelectorAll(appSelector).forEach(function (app) {
      var appSection = app.closest('.shopify-section') || app;
      appSection.classList.toggle('native-boost-app-is-hidden', nativeGridIsActive);
      decorateBoostProductLinks(app);
    });
  }

  function startBoostFallbackObserver() {
    syncBoostFallback();

    if (window.nativeBoostFallbackObserver) return;

    window.nativeBoostFallbackObserver = new MutationObserver(function (mutations) {
      var boostStateMayHaveChanged = mutations.some(function (mutation) {
        if (mutation.type === 'attributes') {
          return mutation.target.matches(appSelector);
        }

        return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
      });

      if (boostStateMayHaveChanged) syncBoostFallback();
    });

    window.nativeBoostFallbackObserver.observe(document.documentElement, {
      attributeFilter: ['class'],
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  startBoostFallbackObserver();
})();
